import type { GameMeta } from "@kit/meta";

export const meta: GameMeta = {
  id: "baskent",
  name: "Başkent Eşle",
  tagline: "Ülkeleri başkentleriyle eşleştir.",
  inspiredBy: "Kart çevirme hafızası × coğrafya bilgisi",
  secondLayer: "Bayrak renklerinden esinlenen ülke kartlarını doğru başkentleriyle eşleştir.",
  accent: "#1982c4",
  status: "lab",
};
